<template>
  <div id="ModalLogout">
    <transition name="fade">
      <div class="fixed inset-0 z-50" v-if="isModalOpen">
        <div
          class="absolute inset-0 bg-black bg-opacity-75"
          @click="toggleModalOpen"
        ></div>
        <div
          class="flex flex-col items-center justify-center w-screen h-screen"
        >
          <div class="relative animodal-inner">
            <div
              class="rounded-lg bg-white border w-[350px] xl:w-[500px] lg:w-[500px] p-6 border-stone-500 overflow-hidden"
            >
              <div class="text-center">
                <font-awesome-icon
                  class="text-red-600 h-20 mb-2"
                  icon="fa-exclamation-triangle"
                />
              </div>
              <div class="mt-4 text-center">
                Are you sure you want to log out?
              </div>
              <div class="flex justify-center my-3">
                <button
                  @click="toggleModalOpen"
                  class="bg-[#8DC63F] text-white rounded-md mr-2 px-7 py-2"
                >
                  No
                </button>
                <button
                  @click="logout()"
                  class="bg-red-600 text-white rounded-md px-7 py-2"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    isModalOpen: Boolean,
    toggleModalOpen: Function,
    logout: Function,
  },
};
</script>

<style></style>
